import { LogoCarousel } from './LogoCarousel';
import { Heading } from './Heading';
import { LogoTrack } from './LogoTrack';
LogoCarousel.displayName = "LogoCarouselBase";
Heading.displayName = "LogoCarousel.Heading";
LogoTrack.displayName = "LogoCarousel.LogoTrack";
export { LogoCarousel as default };
export { Heading, LogoTrack };